import Http from '../index.js'
import Model from '../Model.js'

class Clients extends Model {
  constructor() {
    super('/clients/')
  }

  getByDocument(document, query = '') {
    return Http.post(`${this.model}get_by_document/${query}`, {
      client: Clients._unMaskDocument(document),
    })
  }

  consultDocument(document) {
    return Http.post(`${this.model}consult_document/`, { document })
  }

  addToContacts(document) {
    return Http.post(`${this.model}add_to_contacts/`, {
      client: Clients._unMaskDocument(document),
    })
  }

  removeFromContacts(document) {
    return Http.delete(`${this.model}remove_from_contacts/`, {
      data: {
        client: document,
      },
    })
  }

  importFromCsv(file) {
    return Http.post(`${this.model}import_csv/`, file)
  }

  listPayers(query = '') {
    return Http.get(`${this.model}contacts/${query}`)
  }

  static _unMaskDocument(document) {
    return document.replace(/[^\d]/g, '')
  }

  blockClient(id, payload) {
    return Http.post(`/clients/${id}/block/`, payload)
  }

  unblockClient(id) {
    return Http.post(`/clients/${id}/unblock/`)
  }

  createAddress(payload) {
    return Http.post(`/clients/profile_create_address/`, payload)
  }

  profileInfo(payload, config = {}) {
    return Http.post(`${this.model}profile_info/`, payload, config)
  }

  changeCustodyAccount(payload) {
    return Http.post(`/clients/change_custody_account/`, payload)
  }

  listPublicClients(payload, config = {}) {
    return Http.post(`${this.model}client_checkout_info/`, payload, config)
  }

  updateProfilePicture(payload, config = {}) {
    return Http.post(`${this.model}update_profile_picture/`, payload, config)
  }
}

export default new Clients()
